core.component('core.modeloModalComponent', {
    templateUrl: 'components/drawflow/modeloModal/modeloModal.html',
    controllerAs: '$modal',
    bindings: { config:'=' },
    controller: ['$scope', 'coreLanguage', function($scope, $text) {
        const $ctrl = this;
        $scope.$text = $text;
    
        $ctrl.close=()=>{
            $ctrl.config.show = false;
            $ctrl.config.dados = {};
        };
    
    }]
});